// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__9blA2","content":"PageLayout_content__Lxbbe"};